import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const DelayedInput = ({ value, type, onChange, delay, submitOnBlur, ...rest }) => {
  const [query, setQuery] = useState(value);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    setQuery(value);
  }, [value]);
  useEffect(() => {
    const id = setTimeout(() => setSaving(true), delay);
    return () => clearTimeout(id);
  }, [query, delay]);

  useEffect(() => {
    if (saving) {
      onChange(query);
      setSaving(false);
    }
    return () => {
      setSaving(false);
    };
  }, [onChange, saving, query]);

  const handleBlur = () => {
    if (!submitOnBlur || saving) return;

    // if (timeoutId) clearTimeout(timeoutId);
    if (value !== query) setSaving(true);
  };

  return (
    <input
      {...rest}
      onBlur={handleBlur}
      type={type}
      onChange={e => setQuery(e.target.value)}
      value={query == null ? '' : query}
    />
  );
};

DelayedInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  submitOnBlur: PropTypes.bool,
  delay: PropTypes.number,
};
DelayedInput.defaultProps = {
  value: null,
  type: 'string',
  submitOnBlur: true,
  delay: 500,
};
export default DelayedInput;
